import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const hour = {
  path: '/defects',
  component: Layout,
  name: 'defects',
  redirect: '/defects/index',
  children: [{
    path: '/defects/index',
    component: () => import('@/views/defects/index'),
    name: 'defects.index',
    meta: {
      title: i18n.t(`message.defects`)
    }
  }, ]
}

export default hour